/**
 * The network class the upload telemetry stamps, read as legacy's
 * `apps/app/react_src/components/UploadManager.jsx` reads it
 * (`navigator.connection?.effectiveType`).
 *
 * Shared because two call sites stamp it: the recorder, and the upload run's
 * terminal events (`performUpload.ts`). A second copy would be a second thing
 * to keep in step with legacy's field.
 *
 * @returns the connection's `effectiveType`, or `"unknown"` where the browser
 *   does not implement the Network Information API (every Safari).
 */
export function networkType(): string {
  const connection = (navigator as unknown as { connection?: { effectiveType?: string } })
    .connection;
  return connection?.effectiveType ?? "unknown";
}
